var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetRepairAndRebuildAdministrationQuery } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
export default function RepairXSS() {
    var t = useTranslation(["Administration"]).t;
    var _a = useGetRepairAndRebuildAdministrationQuery({
        params: { action: "getModuleOptions" },
    }), repairAndRebuildData = _a.data, isLoading = _a.isLoading;
    var _b = useGetRepairAndRebuildAdministrationQuery({
        params: { action: "repairXSS" },
    }), repairXSS = _b.data, isLoadingrepairXSS = _b.isLoading;
    var results = repairAndRebuildData === null || repairAndRebuildData === void 0 ? void 0 : repairAndRebuildData.data;
    var resultsXSS = repairXSS === null || repairXSS === void 0 ? void 0 : repairXSS.data;
    var _c = useState(), selectedOption = _c[0], setSelectedOption = _c[1];
    var handleOptionClick = function (event) {
        var selectedValue = event.target.value;
        setSelectedOption(selectedValue);
        // Additional logic can go here, such as updating state or calling an API
    };
    var handleExcecute = function () {
        console.log("Selected option: ".concat(selectedOption));
        toast.success("Done");
    };
    return (_jsxs("div", __assign({ className: "p-10 relative overflow-auto space-x-1" }, { children: [isLoading && _jsx(LoaderImage, {}), _jsxs("p", __assign({ className: "py-1" }, { children: [" ", t("LBL_REPAIRXSS_INSTRUCTIONS")] })), _jsx("select", __assign({ onChange: handleOptionClick, className: "py-1 border" }, { children: results &&
                    Object.entries(results).map(function (_a) {
                        var value = _a[0], label = _a[1];
                        return (_jsx("option", __assign({ value: value }, { children: label }), value));
                    }) })), selectedOption !== "0" && (_jsxs(_Fragment, { children: [_jsx("button", __assign({ className: "button danger", onClick: handleExcecute }, { children: "Execute" })), selectedOption !== "all" && (_jsxs("div", __assign({ className: "py-2" }, { children: [_jsx("input", { type: "text", disabled: true, id: "repairXssCount", value: "0", className: "bg-white" }), t("LBL_REPAIRXSS_COUNT")] })))] }))] })));
}
